<div *ngIf="drawer" class="sb__scrim" (click)="closeDrawer()"></div>

<nav class="sb" [cdkTrapFocus]="drawer" [attr.aria-label]="'shell.mainMenu' | transloco">
  <div class="sb__brand">
    <a class="sb__logo" routerLink="/call-center" aria-label="Happy Cake">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.cake"></path></svg>
    </a>
    <span *ngIf="!folded" class="sb__brand-text">
      <b>Happy Cake</b>
      <span>{{ 'shell.app' | transloco }}</span>
    </span>
    <button *ngIf="!folded" type="button" class="sb__icon-btn sb__fold" [title]="'shell.fold' | transloco" [attr.aria-label]="'shell.fold' | transloco" (click)="toggleFolded()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.foldL"></path></svg>
    </button>
    <button type="button" class="sb__icon-btn sb__close" [attr.aria-label]="'shell.closeMenu' | transloco" (click)="closeDrawer()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path [attr.d]="icon.close"></path></svg>
    </button>
  </div>

  <div *ngIf="shift" class="sb__shift-wrap">
    <div *ngIf="!folded; else miniShift" class="sb__shift sb__shift--{{ shift.kind }}">
      <span class="sb__deco" aria-hidden="true"><i></i><i></i></span>
      <button type="button" class="sb__who" aria-haspopup="menu" [attr.aria-expanded]="userMenu" [attr.aria-label]="'shell.shift.menu' | transloco" (click)="toggleUserMenu($event)">
        <span class="sb__avatar">{{ initials }}<i class="sb__presence" [class.is-off]="shift.kind === 'offline'"></i></span>
        <span class="sb__names">
          <b>{{ userName }}</b>
          <span>{{ shift.role }}</span>
        </span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.down"></path></svg>
      </button>
      <div class="sb__status" role="status">
        <span class="sb__status-line"><i class="sb__dot"></i>{{ shift.title }}</span>
        <span *ngIf="shift.sub" class="sb__status-sub">{{ shift.sub }}</span>
      </div>
      <button *ngIf="shift.action" type="button" class="sb__act" (click)="shiftAction($event)">{{ shift.action.label }}</button>
      <ng-container *ngIf="today && (shift.kind === 'idle' || shift.kind === 'finished')">
        <div class="sb__today">
          <span><b>{{ today.calls }}</b>{{ today.callsWord }}</span>
          <span><b>{{ today.orders }}</b>{{ today.ordersWord }}</span>
          <span><b>{{ today.sales }}</b>{{ today.salesWord }}</span>
        </div>
        <span class="sb__today-cap">{{ 'shell.shift.today' | transloco }}</span>
      </ng-container>
    </div>

    <ng-template #miniShift>
      <button type="button" class="sb__mini sb__mini--{{ shift.kind }}" aria-haspopup="menu" [attr.aria-expanded]="userMenu" [title]="shift.title" [attr.aria-label]="'shell.shift.menu' | transloco" (click)="toggleUserMenu($event)">
        {{ initials }}
      </button>
      <span *ngIf="shift.live" class="sb__mini-live">{{ shift.live }}</span>
    </ng-template>

    <div *ngIf="userMenu" class="sb__menu" role="menu">
      <div class="sb__menu-head">
        <span class="sb__menu-avatar">{{ initials }}</span>
        <span class="sb__names">
          <b>{{ userName }}</b>
          <span>{{ shift.role }}</span>
          <span class="sb__menu-net" [class.is-off]="shift.kind === 'offline'"><i></i>{{ (shift.kind === 'offline' ? 'shell.shift.noConnection' : 'shell.shift.online') | transloco }}</span>
        </span>
      </div>
      <div class="sb__menu-list">
        <button type="button" role="menuitem" class="sb__menu-item" (click)="changeNumber()">
          <span class="sb__menu-tile"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.swap"></path></svg></span>
          {{ 'shell.number.change' | transloco }}
        </button>
        <a role="menuitem" class="sb__menu-item" target="_blank" rel="noopener" [href]="profileUrl" (click)="userMenu = false">
          <span class="sb__menu-tile"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.user"></path></svg></span>
          <span class="sb__grow">{{ 'shell.user.myProfile' | transloco }}</span>
          <svg class="sb__ext" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.external"></path></svg>
        </a>
        <button type="button" role="menuitem" class="sb__menu-item" (click)="go('/clients')">
          <span class="sb__menu-tile"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.clients"></path></svg></span>
          {{ 'mainmenu.clients' | transloco }}
        </button>
        <button type="button" role="menuitem" class="sb__menu-item" (click)="go('/feedbacks-new')">
          <span class="sb__menu-tile"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.star"></path></svg></span>
          {{ 'mainmenu.feedbacks-new' | transloco }}
        </button>
        <button type="button" role="menuitem" class="sb__menu-item sb__menu-item--out" (click)="logout()">
          <span class="sb__menu-tile"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.out"></path></svg></span>
          {{ 'mainmenu.logout' | transloco }}
        </button>
      </div>
      <span class="sb__menu-foot">{{ 'shell.version' | transloco: { version: version } }}</span>
    </div>
  </div>

  <div class="sb__nav">
    <ng-container *ngIf="!folded; else railTpl">
      <ng-container *ngFor="let r of rows; trackBy: trackRow">
        <span *ngIf="r.kind === 'label'" class="sb__label">{{ r.title | transloco }}</span>

        <a *ngIf="r.kind === 'item'" class="sb__item sb__item--{{ r.tone }}" routerLinkActive="is-active" ariaCurrentWhenActive="page" [routerLink]="r.link" [queryParams]="r.queryParams"
          [routerLinkActiveOptions]="activeOptions">
          <span class="sb__tile" aria-hidden="true"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="r.icon"></path></svg></span>
          <span class="sb__text">{{ r.title | transloco }}</span>
          <span *ngIf="r.live" class="sb__live"><i></i>{{ r.live }}</span>
          <span *ngIf="r.badge" class="sb__badge" [title]="'shell.late' | transloco: { n: r.badge }"><i></i>{{ r.badge }}</span>
        </a>

        <ng-container *ngIf="r.kind === 'oldToggle'">
          <button type="button" class="sb__item sb__item--old sb__toggle" [class.is-open]="oldOpen" [attr.aria-expanded]="oldOpen" (click)="toggleOld()">
            <span class="sb__tile" aria-hidden="true"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="r.icon"></path></svg></span>
            <span class="sb__text">{{ r.title | transloco }}</span>
            <span class="sb__count">{{ oldRows.length }}</span>
            <svg class="sb__chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.right"></path></svg>
          </button>
          <div *ngIf="oldOpen" class="sb__olds">
            <a *ngFor="let o of oldRows; trackBy: trackRow" class="sb__item sb__item--old sb__item--small" routerLinkActive="is-active" ariaCurrentWhenActive="page" [routerLink]="o.link" [queryParams]="o.queryParams"
              [routerLinkActiveOptions]="activeOptions">
              <span class="sb__tile" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="o.icon"></path></svg></span>
              <span class="sb__text">{{ o.title | transloco }}</span>
            </a>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #railTpl>
      <ng-container *ngFor="let r of rail; trackBy: trackRow">
        <span *ngIf="r.sep" class="sb__rail-sep" aria-hidden="true"></span>
        <a *ngIf="r.kind === 'item'" class="sb__rail sb__item--{{ r.tone }}" routerLinkActive="is-active" ariaCurrentWhenActive="page" [routerLink]="r.link" [queryParams]="r.queryParams"
          [routerLinkActiveOptions]="activeOptions" [attr.aria-label]="r.title | transloco" (mouseenter)="showTip($event, r)" (mouseleave)="hideTip()" (focus)="showTip($event, r)" (blur)="hideTip()">
          <span class="sb__tile" aria-hidden="true"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="r.icon"></path></svg></span>
          <i *ngIf="r.live" class="sb__rail-live"></i>
          <span *ngIf="r.badge" class="sb__rail-badge">{{ r.badge }}</span>
        </a>
        <button *ngIf="r.kind === 'oldToggle'" type="button" class="sb__rail sb__item--old" [attr.aria-label]="r.title | transloco" (mouseenter)="showTip($event, r)" (mouseleave)="hideTip()"
          (focus)="showTip($event, r)" (blur)="hideTip()" (click)="toggleOld()">
          <span class="sb__tile" aria-hidden="true"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="r.icon"></path></svg></span>
        </button>
      </ng-container>
    </ng-template>
  </div>

  <span *ngIf="tip" class="sb__tip" role="tooltip" [style.top.px]="tip.top" [style.left.px]="tip.left">{{ tip.text }}</span>

  <div class="sb__foot">
    <span *ngIf="!folded">{{ 'shell.version' | transloco: { version: version } }}</span>
    <button *ngIf="folded" type="button" class="sb__icon-btn" [title]="'shell.unfold' | transloco" [attr.aria-label]="'shell.unfold' | transloco" (click)="toggleFolded()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.foldR"></path></svg>
    </button>
  </div>
</nav>
